"use strict";

exports.__esModule = true;
exports.default = void 0;

var choose = function () {
  return Promise.reject();
};

var _default = choose;
exports.default = _default;